import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { RiderService } from 'src/app/Service/Rider/rider.service';
import { GoogleCustomer } from 'src/app/Model/Common/google-customer';
import { RiderDetails } from 'src/app/Model/Rider/rider-details';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { logOutApp } from 'src/myfunc';
import { WebSocketService } from 'src/app/Common/WebSocketService';
import { JwtService } from 'src/app/Service/Common/jwt.service';
import { environment } from 'src/environments/environment';
import { getWindow } from 'ssr-window';
import { AppConfigService } from 'src/app/Service/Configuration/app-config.service';
declare var google: any;
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {

  auth2: any;
  @ViewChild("loginRef", { static: true }) loginElement!: ElementRef;
  isSignIn: boolean = false;
  name: any;

  riderDetails: RiderDetails = new RiderDetails();

  googleCustomer = new GoogleCustomer();

  private getRiderSubscription: Subscription;

  constructor(
    private riderService: RiderService,
    private localStorage: LocalStorageService,
    private toastrService: ToastrService,
    private ngZone: NgZone,
    private router: Router,
    private webSocketService: WebSocketService,
    private route: ActivatedRoute,
    private jwtService: JwtService,
    private appConfig: AppConfigService
  ) {
    if (this.getOS() == 'Android') {
      logOutApp();
      return;
    } else {
      window.location.href = this.appConfig.setting.loginLogoutUrl + "signin?cnt=1&source=" + window.location.origin + "/";
    }

  }

  ngOnInit(): void {
    // this.testPush("my-coupon-babuli.sahu@mobitrix.in")
    // this.riderDetails.isVerified = false;
    // this.route.queryParams.subscribe(params => {
    //   let token = params['id_token'];
    //   alert('Token: ' + token);


    //   if (!token) {
    //     const urlParams = new URLSearchParams(window.location.search);
    //     token = urlParams.get('id_token');
    //   }

    //   alert('Token: ' + token);

    //   if (token) {
    //     try {
    //       const decoded: any = jwt_decode(token);
    //       const email = decoded.email;

    //       if (email) {
    //         this.callLogin(decoded);
    //       } else {
    //         console.error('Email not found in token');
    //         this.router.navigate(['/']);
    //       }
    //     } catch (err) {
    //       console.error('Failed to decode JWT', err);
    //       this.router.navigate(['/']);
    //     }
    //   } else {
    //     // No token, go to Google login
    //     const isLoggedIn = this.localStorage.get('google_email');
    //     if (!isLoggedIn) {
    //       window.location.href = 'https://testriderlogin.mobitrix.net';
    //     } else {
    //       // Already logged in, move to root (AppComponent will handle)
    //       this.router.navigate(['/']);
    //     }
    //   }
    // });
  }

  ngAfterViewInit() {
    // this.name = JSON.parse(this.localStorage.get("google_item"));
    // console.log("Login ==> " + this.name)
    // if (this.name) {
    //   this.route.navigate([""]);
    // } else {
    //   // this.externalLogin();
    //   // this.googleAuthSDK();

    //   // fetch('https://testriderlogin.mobitrix.net', {
    //   //   method: 'GET',
    //   //   headers: {
    //   //     'Content-Type': 'application/json'
    //   //   }
    //   // })
    //   //   .then(response => response.json())
    //   //   .then(data => {
    //   //     console.log('API Response:', data);
    //   //     this.route.navigate([""]);
    //   //   })
    //   //   .catch(error => {
    //   //     console.error('Error calling API:', error);
    //   //   });


    //   // google.accounts.id.initialize({
    //   //   client_id: "1027135256757-9t4carlh4l1e9tqh500ihenulgcsjon3.apps.googleusercontent.com",
    //   //   ux_mode: 'popup',
    //   //   cancel_on_tap_outside: true,
    //   //   callback: ({ credential }) => {
    //   //     this.ngZone.run(() => {
    //   //       this._loginWithGoogle(credential);
    //   //     });
    //   //   },
    //   // });

    //   // google.accounts.id.renderButton(
    //   //   document.getElementById("googleButton"),
    //   //   {
    //   //     type: "standard", text: "signin_with",
    //   //     theme: "filled_blue", size: "medium", shape: "rectangular"
    //   //   }
    //   // )
    // }
  }

  // externalLogin() {
  //   this.activeRoute.queryParams.subscribe(params => {
  //     const message = params['id_token'];
  //     if (message != undefined) {
  //       try {
  //         console.log('Decoded JWT:', message.replace(":", ""));
  //         const userEmail = this.jwtService.getClaim(message.replace(":", ""), 'email');
  //         console.log('User Email:', userEmail);
  //         this._loginWithGoogle(message.replace(":", ""));
  //       } catch (error) {
  //         console.error('Invalid token', error);
  //         return null;
  //       }
  //     }
  //   });
  // }

  private _loginWithGoogle(token: string) {
    console.log(jwt_decode(token))
    this.callLogin(JSON.parse(JSON.stringify(jwt_decode(token))));
  }

  callLogin(googleAuthUser: any) {
    this.isSignIn = false;
    // this.auth2.attachClickHandler(this.loginElement.nativeElement, {}, (googleAuthUser: any) => {
    //Print profile details in the console logs
    localStorage.setItem("showSignIn", "true");
    //let profile = googleAuthUser.getBasicProfile();
    // console.log("Token || " + googleAuthUser.getAuthResponse().id_token);
    console.log("ID: " + googleAuthUser.email);
    console.log("Name: " + googleAuthUser.name);
    console.log("Image URL: " + googleAuthUser.picture);
    console.log("Email: " + googleAuthUser.email);

    this.isSignIn = true;
    this.googleCustomer.id = googleAuthUser.email;
    this.googleCustomer.name = googleAuthUser.name;
    this.googleCustomer.email = googleAuthUser.email;
    this.googleCustomer.firstName = googleAuthUser.given_name;
    this.googleCustomer.lastName = googleAuthUser.family_name;
    this.googleCustomer.idToken = googleAuthUser.email;
    this.googleCustomer.authToken = googleAuthUser.nbf;
    this.googleCustomer.provider = "GOOGLE";

    console.log(this.googleCustomer);

    this.localStorage.set("google_loggedIn_details", JSON.stringify(this.googleCustomer));
    this.localStorage.set("google_email", JSON.stringify(this.googleCustomer.email));
    this.localStorage.set("google_item", JSON.stringify(this.googleCustomer.name));
    this.localStorage.set("google_id", JSON.stringify(this.googleCustomer.id));
    this.localStorage.set("google_provider", JSON.stringify(this.googleCustomer.provider));
    if (this.googleCustomer) {
      this.getRiderByEmail(this.googleCustomer.email);
      // this.route.navigate(["/home", { 'id': this.isSignIn }]);
    }
    else {
      this.isSignIn = false;
    }
    // },
    //   (error: any) => {
    //     alert(JSON.stringify(error, undefined, 2));
    //   }
    // );
  }

  getRiderByEmail(googleEmailId: string) {
    this.getRiderSubscription = this.riderService.getRiderByEmail(googleEmailId).subscribe((data) => {
      console.log("Received Data Login1:"+data)
      if (data) {
        this.riderDetails = data;
        this.localStorage.set("rider_details", JSON.stringify(this.riderDetails));
        this.localStorage.set('locId', JSON.stringify(this.riderDetails.fromLocationCode));
        this.localStorage.set("active_rider_status", this.riderDetails.activeStatus ? 'true' : 'false');
        this.toastrService.showSuccessToast("Sucessfully Logged In");
        // this.route.navigateByUrl('');
      } else {
        this.router.navigateByUrl('/rider-details');
      }
      window.location.reload();
    });
  }



  googleAuthSDK() {

    (<any>window)['googleSDKLoaded'] = () => {
      (<any>window)['gapi'].load('auth2', () => {
        this.auth2 = (<any>window)['gapi'].auth2.init({
          client_id: '914093533371-afrbki9nq2pvqsik1bj3q57fuct4vb0h.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
          scope: 'profile email'
        });

        this.callLoginButton();
      });
    }

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement('script');
      js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
      fjs?.parentNode?.insertBefore(js, fjs);
    }(document, 'script', 'google-jssdk'));

  }
  callLoginButton() {

    this.auth2.attachClickHandler(this.loginElement.nativeElement, {},
      (googleAuthUser: any) => {

        let profile = googleAuthUser.getBasicProfile();
        // console.log('Token || ' + googleAuthUser.getAuthResponse().id_token);
        // console.log('ID: ' + profile.getId());
        // console.log('Name: ' + profile.getName());
        // console.log('Image URL: ' + profile.getImageUrl());
        // console.log('Email: ' + profile.getEmail());
        this._loginWithGoogle(googleAuthUser.getAuthResponse().id_token)
        /* Write Your Code Here */

      }, (error: any) => {
        alert(JSON.stringify(error, undefined, 2));
      });

  }

  testPush(id: any) {
    id = id.replaceAll("\"", "")
    let stompClient = this.webSocketService.connect();
    stompClient.connect(
      {},
      (frame) => {
        stompClient.subscribe('/topic/' + id + '/notification', (notifications) => {
          alert(notifications.body);
        });
      },
      (err) => {
        if (err.includes('Lost connection to')) {
          setTimeout(() => {
            this.testPush(id);
          }, 5000);
        }
      }
    );
  }

  getOS() {
    var uA = getWindow().navigator.userAgent || getWindow().navigator.vendor;
    if (
      /iPad|iPhone|iPod/.test(uA) ||
      (uA.includes('Mac') && 'ontouchend' in document)
    )
      return 'iOS';
    var i,
      os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], 'i').test(uA)) return os[i];
  }
}

